import React from "react";
import FieldDate from "../../../../generic/datetime/date/date";
import FieldConfig from "../../../../proto/field-config";
import Project from "../../../../../model2/project/project";

export default class FieldProjectDeadline extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Deadline";
        this.icon               = 'i5-deadline';
        this.label              = _.get(config, 'label', "Project Deadline")

        this.fieldParams.highlightIfPastdue     = true

        _.assign(this.components, {
            ValueIcon: <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>  // drugaya z icon
        })
    }

    canEdit(model: Project): boolean {
        return model.acl.canChangeDeadline
    }


}